module.exports = __webpack_public_path__ + "54351062a9ea91c5edb0464d4eee021c.png";